/**
 * UserPopper - Display Profile Avatar with
 * Dropdown options ( My Profile, Bookmarks, Help,
 * Logout )
 * and redirecting router link
 *
 * @version 1.0.1
 * @author [Gopinath Bhathey Srinivasan](https://github.com/gopinath-sixt)
 */
import * as React from 'react'
import {NavLink, useLocation} from 'react-router-dom'
import classNames from 'classnames'
import {
  Button,
  Divider,
  Fade,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from '@mui/material'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import ADFSAvatar from '../common/ADFSAvatar/ADFSAvatar'
import './userPopper.scss'

const UserPopper: React.FC = () => {
  const [showPopper, setShowPopper] = React.useState(false)
  const anchorElRef = React.useRef<HTMLButtonElement>(null)
  const location = useLocation()

  const handleToggle = (show: boolean) => {
    setShowPopper(show)
  }

  // Close popper when location changes
  React.useEffect(() => {
    if (showPopper) {
      handleToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <div className="user-avatar">
      <Button
        ref={anchorElRef}
        className={classNames('user-btn', {active: showPopper})}
        aria-haspopup="true"
        data-testid="user-btn"
        onClick={() => handleToggle(true)}
      >
        <ADFSAvatar className="profile_pic avatar" />
      </Button>
      <Popper
        open={showPopper}
        anchorEl={anchorElRef.current}
        transition={true}
        className="user-popper"
      >
        {({TransitionProps}) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className="user-paper">
              <ClickAwayListener onClickAway={() => handleToggle(false)}>
                <MenuList>
                  <MenuItem>
                    <NavLink
                      className={({isActive}) => (isActive ? 'active' : '')}
                      to="/profile"
                    >
                      My Profile
                    </NavLink>
                  </MenuItem>
                  {/* <MenuItem>
                    <a
                      href="https://sixtbook.sixt.com/my-bookmarks"
                      target="_blank"
                    >
                      Bookmarks
                    </a>
                  </MenuItem> */}
                  {/* <MenuItem onClick={() => handleToggle(false)}>
                    <a
                      href="https://sixtbook.sixt.com/content/sixtbook-help-0"
                      target="_blank"
                    >
                      Help
                    </a>
                  </MenuItem> */}
                  <Divider />
                  <MenuItem>
                    <NavLink
                      className={({isActive}) => (isActive ? 'active' : '')}
                      to="/logout"
                    >
                      Logout
                    </NavLink>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  )
}

export default UserPopper
